
export function AirDuctIcon({ color, height, width }: any) {
    return (
        <svg  width={width || '100%'} height={height || '100%'} version="1.1" x="0px" y="0px" viewBox="0 0 36 36" enableBackground="new 0 0 36 36"><g>
            <path fill={color} d="M34,19.5H22c0-0.55-0.45-1-1-1h-4c-0.55,0-1,0.45-1,1H2c-0.55,0-1,0.45-1,1v6c0,0.55,0.45,1,1,1h14c0,0.55,0.45,1,1,1h4   c0.55,0,1-0.45,1-1h12c0.55,0,1-0.45,1-1v-6C35,19.95,34.55,19.5,34,19.5z M16,25.5H3v-4h13V25.5z M20,26.5h-2v-6h2V26.5z M33,25.5   H22v-4h11V25.5z"></path>
            <path fill={color} d="M34,8.5H22c0-0.55-0.45-1-1-1h-4c-0.55,0-1,0.45-1,1H2c-0.55,0-1,0.45-1,1v6c0,0.55,0.45,1,1,1h14c0,0.55,0.45,1,1,1h4   c0.55,0,1-0.45,1-1h12c0.55,0,1-0.45,1-1v-6C35,8.95,34.55,8.5,34,8.5z M16,14.5H3v-4h13V14.5z M20,15.5h-2v-6h2V15.5z M33,14.5H22   v-4h11V14.5z"></path>
        </g></svg>

    );
}